import { Stack, Typography } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { SelectField } from '@mews-commander/form';
import { usePaymentChargingOptions } from '../../hooks';

interface Props {
    selectedService: string;
}

export const ServicesPayments = ({ selectedService }: Props) => {
    const { chargingFieldName, consumptionFieldName, subOptions, selectedOption, options } = usePaymentChargingOptions({
        selectedService,
    });

    return (
        <>
            <Typography textStyle="bodyLargeStrong" as="div">
                {lt('ConfigureProductServicesSubHeadingPayments')}
            </Typography>
            <Stack spacing="50" distribution="stretch">
                <SelectField
                    disableInputSearch
                    required
                    readOnly={options.length === 1}
                    name={chargingFieldName}
                    options={options}
                    label={lt('ConfigureProductServicesPaymentsCharging')}
                />
                <SelectField
                    disableInputSearch
                    required
                    readOnly={subOptions?.length === 1}
                    name={consumptionFieldName}
                    options={subOptions ?? []}
                    label={lt('ConfigureProductServicesPaymentsTiming')}
                    disabled={!selectedOption}
                />
            </Stack>
        </>
    );
};
